<div class="auth-callback-container">
  <div class="auth-callback-card">
    <h1>Signing you in...</h1>
    @if (isLoading()) {
      <div class="loader"></div>
      <p>Please wait while we complete Azure authentication.</p>
    } @else {
      <p class="error">{{ errorMessage() || 'Authentication failed. Redirecting to login...' }}</p>
    }
  </div>
</div>
